// extracted by mini-css-extract-plugin
module.exports = {"root":"manageFAQ_root__7EjpG","checkboxes":"manageFAQ_checkboxes__1S6EY"};